module.exports = __webpack_public_path__ + "static/media/ZCMD01.ef465541.jpg";